import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { AlertDirective } from '@shared/directives'
import { IncommingChipsAlertModel } from '@shared/model'
import { IncommingChipsType } from '@shared/types'

@Component({
  selector: 'app-chips-alert',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, AlertDirective],
  templateUrl: './chips-alert.component.html',
  styleUrl: './chips-alert.component.sass',
})
export class ChipsAlertComponent {
  @Input() incommingChipsAlert: IncommingChipsAlertModel
  @Input() durationSec = 3

  @Output() onEnded = new EventEmitter<boolean>()

  readonly faPlus = faPlus
  readonly faMinus = faMinus

  get icon() {
    return this.incommingChipsAlert.type === 'add' ? this.faPlus : this.faMinus
  }

  constructor() {}

  showChange(show: boolean) {
    this.onEnded.emit(show)
  }
}
